var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { internalMessageBus } from "sb-internal-msg-bus";
import { BaseDict } from "./dict";
import { config } from "./config";
import { Scoreboard } from "./Scoreboard";
import { ScoreboardData } from "./data";
import { Parser } from "../../Parser";
import { Retriever } from "../../Retriever";
var _LOCALMOCKSTYPE;
var BaseballScoreboardDataMock;
if (process.env.NODE_ENV === "development") {
    _LOCALMOCKSTYPE = require("../../Mocks");
    BaseballScoreboardDataMock = _LOCALMOCKSTYPE.BaseballScoreboardDataMock;
}
var ScoreboardRoot = /** @class */ (function (_super) {
    __extends(ScoreboardRoot, _super);
    function ScoreboardRoot(domId, options) {
        if (options === void 0) { options = {
            //TO Do delete unused properties
            dict: BaseDict,
            cms: {},
            dataProvider: {},
            panelId: "",
        }; }
        var _this = _super.call(this, domId, options) || this;
        if (process.env.NODE_ENV === "development") {
            _this.dataProvider = new ScoreboardData(new Parser(new Retriever(internalMessageBus, "url(test.png)")));
            window["ScoreboardDATA"] = _this.dataProvider;
            window["BaseballScoreboardDataMock"] = new BaseballScoreboardDataMock(internalMessageBus);
            window["BaseballScoreboardDataMock"].activate();
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            _this.dataProvider = new ScoreboardData(new Parser(new Retriever(options.dataProvider.messageBus, options.dataProvider.backgroundImg)));
        }
        _this.options.dict = __assign({}, BaseDict, (options.dict || {}));
        _this.options.cms = __assign({}, config, (options.cms || {}));
        return _this;
    }
    ScoreboardRoot.prototype.activate = function () {
        this.dataProvider.activate();
        return _super.prototype.activate.call(this, React.createElement(Scoreboard, { dataProvider: this.dataProvider, dict: this.options.dict }));
    };
    ScoreboardRoot.prototype.deactivate = function () {
        this.dataProvider.deactivate();
        return _super.prototype.deactivate.call(this);
    };
    return ScoreboardRoot;
}(BaseBlock));
export { ScoreboardRoot };
window["Scoreboard"] = ScoreboardRoot;
broadcastBlockLoad("Scoreboard");
//# sourceMappingURL=index.js.map